__turbopack_context__.v({
  "ColumnContent": "column-module__haGgNa__ColumnContent",
  "ColumnFilter": "column-module__haGgNa__ColumnFilter",
  "ColumnFilterValue": "column-module__haGgNa__ColumnFilterValue",
  "ColumnHeader": "column-module__haGgNa__ColumnHeader",
  "ColumnTitle": "column-module__haGgNa__ColumnTitle",
  "Loading": "column-module__haGgNa__Loading",
});
